<template>
  <div v-if="isOpen">
    <div class="popup-bg" @click="closePopup" :style="style"></div>
    <div class="popup-area">
      <section class="popup" @click="doNothing">
        <header>
          <h2 style="text-align: center;">Ganhadores!</h2>
        </header>

        <div class="content">
          <div class="winner-item" v-for="(winner, index) in campaign.winners" :key="winner.id">
            <div class="winner-item-place">
              {{ index + 1 }} lugar
            </div>
            <div class="winner-item-content-name" v-if="winner.user_winner">
              {{ winner.user_winner.name }} {{ winner.user_winner.lastname }}
            </div>
            <div class="winner-item-content-cpf" v-if="winner.user_winner">
              {{ maskCPF(winner.user_winner.document) }}
            </div>
            <div class="winner-item-prize" v-if="winner.prize">
              <span style="font-weight: bold;">Prêmio</span>: {{ winner.prize }}
            </div>
            <div>
              Número sorteado: {{ winner.number }}
            </div>
            <div v-if="winner.ticket_number">
              Número do ticket: {{ winner.ticket_number }}
            </div>
          </div>
        </div>

        <footer style="text-align: center;">
          <button class="primary" @click="closePopup">fechar</button>
        </footer>
      </section>
    </div>
  </div>
</template>


<script>
import CampaignMixin from "../mixins/campaign.mixin.js";
// import moment from "moment";

export default {
  mixins: [CampaignMixin],
  name: "popupContent",
  components: {},
  data: function () {
    return {
      okModel: "",
      pdfUrl: '',
      pdfLoaded: false,
    };
  },
  props: {
    isOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    if (this.campaign?.rules_file?.url) {
      this.pdfUrl = `https://docs.google.com/gview?url=${this.campaign.rules_file.url}&embedded=true`
    }
  },
  watch: {
    isOpen(newValue) {
      if (newValue && this.pdfUrl) {

        setTimeout(() => {
          this.loadPdf()
        }, 1000)
      } else if (!newValue) this.pdfLoaded = false
    },
  },
  methods: {
    closePopup() {
      this.$emit("closed");
      //   this.isOpen = false;
    },
    doNothing() { },
    maskCPF(cpf) {
      if (!cpf) return '';
      const numbers = cpf.replace(/\D/g, '');

      if (numbers.length < 11) return cpf;

      const firstThree = numbers.slice(0, 3);
      const lastTwo = numbers.slice(-2);

      return `${firstThree}.***.***-*${lastTwo}`;
    },
    loadWinners() {
      if (this.pdfLoaded) {
        clearTimeout(timeoutPdf)
        return
      }

      console.log("pdfLoaded", this.pdfLoaded)
      const iframe = this.$refs.pdfViewer;
      iframe.src = this.pdfUrl;

      if (iframe) {
        const iframeDoc = iframe.contentDocument;

        if (iframeDoc?.body?.innerHTML.trim() === '') {
          console.log('O conteúdo do iframe está vazio')
          this.pdfLoaded = false
        } else this.pdfLoaded = true
      }

      const timeoutPdf = setTimeout(this.loadPdf, 1000)
    },
  },
};
</script>


<style  lang="scss" scoped>
@import "../scss/colors.scss";

.popup-bg,
.popup-area {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1000;
}

.popup {
  margin: auto;
  margin-top: 25px;
  width: 90%;
  max-height: 85vh;
  max-width: 840px;
  background: white;
  padding: 25px 15px;
  border-radius: 8px;
  z-index: 1001;
  top: 0;

  header {
    margin-bottom: 10px;
    padding-bottom: 10px;

    h2 {
      background: transparent;
      margin-bottom: 10px;
    }
  }

  .content {
    max-height: 58vh;
    color: $text-color;
    overflow-x: scroll;
    display: grid;
    gap: 30px;

    .winner-item {
      display: grid;
      gap: 8px;

      .winner-item-place {
        font-size: 20px;
        font-weight: bold;
        color: var(--primary);
      }

      .winner-item-content-name {
        font-size: 22px;
        font-weight: bold;
      }

      .winner-item-content-cpf {
        font-size: 18px;
        font-weight: bold;
      }

    }
  }

  footer {
    margin-top: 10px;
    padding-top: 10px;

    button {
      width: auto;
      height: auto;
      padding: 10px 20px;
      // margin-top: 10px;
    }
  }
}
</style>